/**
 * VUE COMPONENTS
 * Declare and register any custom Vue components
 */

import Vue from "vue";
import Accordion from "./components/Accordion";
import GoogleMap from "./components/mapping/GoogleMap";
import Marker from "./components/mapping/Marker";
import InfoWindow from "./components/mapping/InfoWindow";
import LayeredMap from "./components/mapping/LayeredMap";
import MapLayer from "./components/mapping/MapLayer";

// Mapping
Vue.component('google-map', GoogleMap);
Vue.component('map-marker', Marker);
Vue.component('info-window', InfoWindow);
Vue.component('layered-map', LayeredMap);
Vue.component('map-layer', MapLayer);

// UI
Vue.component('accordion', Accordion);
